import {observer} from 'mobx-react-lite'
import React from 'react'
import {Lang} from 'yougile-lang'
import {Loading} from '@components/common/loading/loading'
import {Popup} from '@components/common/popup/popup'
import {ProgressBar} from '@components/common/progress-bar/progress-bar'
import {Description} from './description/description'
import {FileInput} from './file-input/file-input'
import {ImportFromFilePopupFooter} from './import-from-file-popup-footer'
import {useImportFromFileStore} from './import-from-file-store'

const getProjectNamesMessage = (projectNames: string[]): string => {
  const len = projectNames?.length
  if (!len) {
    return ''
  }

  const lang = Lang.msg.importFromFile
  const preMessage = len === 1 ? lang.projectCreated : lang.projectsCreated

  const namesWithQuotes = projectNames.map(name => `"${name}"`).join(', ')
  return `${preMessage} ${namesWithQuotes}`
}

export const ImportFromFilePopup = observer(() => {
  const [state, store] = useImportFromFileStore()
  if (!state.open) {
    return null
  }

  const onClosePopup = () => store.close()

  const successfulMessage = Lang.msg.importFromFile.importFinished

  return (
    <Popup
      className="z-2000"
      autoHeight
      width={740}
      close={onClosePopup}
      title={Lang.msg.importFromFile.importFromXLSX}
      footer={<ImportFromFilePopupFooter />}
      contentClassName={'pt-16 pr-24 pl-24 pb-16'}
    >
      <Description />
      <FileInput />
      {state.loading && (
        <div className="flex pt-16 justify-center">
          <Loading />
          {state.loadingProgress > 0 && (
            <ProgressBar
              value={state.loadingProgress}
              maxValue={100}
              className="w-200"
            />
          )}
        </div>
      )}
      {state.imported && (
        <div className="text-success-old pt-16 font-semibold">
          {`${successfulMessage} ${getProjectNamesMessage([
            ...state.projectNames
          ])}`}
        </div>
      )}
      {!!state.errors.length && (
        <div className="pt-16">
          {state.errors.map((error, i) => (
            <div className="text-error-old" key={i}>
              {error}
            </div>
          ))}
        </div>
      )}
    </Popup>
  )
})
